<app-dialog-heading heading='Add Observations'></app-dialog-heading>

<mat-dialog-content>
  <div class="filtering-container">
    <app-element-multi-select displayLabel="Filter Benefit Family"
                              [options]="familyOfBenefits()"
                              [defaultValues]="selectedFamilyOfBenefits()"
                              (selectedValuesChange)="onSelectedFamilyOfBenefitsChanged($event)"
                              [disabled]="observationFilterControl.value != ''">
    </app-element-multi-select>
    <mat-form-field class="filter-input-field" [floatLabel]="'always'">
      <mat-label>Find an observation by keyword</mat-label>
      <input matInput [formControl]="observationFilterControl" placeholder="ex: blood pressure"/>
      <mat-icon matSuffix (click)="clearObservationFilter()">clear</mat-icon>
    </mat-form-field>
  </div>
  
  <mat-divider></mat-divider>
  
  @if (observationTypeFormArray != null && observationFilterControl.value == '') {
    @for (familyOfBenefit of getSelectedFamilyOfBenefits(); track familyOfBenefit) {
      <div class="benefit-family-grouping">
        <h2 class="benefit-family-grouping-title">{{ familyOfBenefit }}</h2>
        <mat-grid-list cols="2" rowHeight="90px" class="grouped-container">
          @for (subObservationTypeGroup of getControlsByFamilyOfBenefitGrouping(familyOfBenefit); track subObservationTypeGroup) {
            <mat-grid-tile>
              @if (subObservationTypeGroup.get('valueType').value === 'DDL') {
                <mat-form-field class="w-90">
                  <mat-label>{{ subObservationTypeGroup.get('name').value }}</mat-label>
                  <mat-select #selectDDLElement
                              placeholder="Select Option"
                              [formControl]="subObservationTypeGroup.get('value')">
                    @for (option of subObservationTypeGroup.get('options').value; track option.name) {
                      <mat-option [value]="option?.name">
                        {{ option?.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                    <button mat-icon-button matSuffix
                            (click)="clearSelection(selectDDLElement)">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                    <span matSuffix class="font-small">
                      <mat-icon [ngStyle]="{'color': 'green'}">done_outline</mat-icon>
                    </span>
                  }
                </mat-form-field>
              } @else {
                <!-------------------------------------->
                  <!-- Container (Field + Date Field) -->
                  <!-------------------------------------->
                @if (subObservationTypeGroup.get('showEffectiveDate')?.value === 1) {
                  <div class="flex flex-auto justify-center">
                    <div class="w-60">
                      <ng-container *ngTemplateOutlet="defaultField;"></ng-container>
                    </div>
                    <!-------------------------------------->
                    <!-- Date Field -->
                    <!-------------------------------------->
                    <div class="w-30">
                      <mat-form-field class="w-90">
                        <mat-label>Effective Date</mat-label>
                        <input [formControl]="subObservationTypeGroup.get('effectiveDate')"
                               [matDatepicker]="completionDatePicker" matInput>
                        <mat-datepicker-toggle [for]="completionDatePicker" matIconSuffix>
                        </mat-datepicker-toggle>
                        <mat-datepicker #completionDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                } @else {
                  <ng-container *ngTemplateOutlet="defaultField;"></ng-container>
                }
              }
            </mat-grid-tile>
            
            <ng-template #defaultField>
              <mat-form-field class="w-90">
                <mat-label>{{ subObservationTypeGroup.get('name').value }}</mat-label>
                <input [formControl]="subObservationTypeGroup.get('value')"
                       placeholder="{{subObservationTypeGroup.get('valueType').value}}"
                       [type]="getInputType(subObservationTypeGroup.get('valueType').value)"
                       [pattern]="getInputPattern(subObservationTypeGroup.get('valueType').value)"
                       matInput>
                <span matSuffix class="font-small">
                  @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                    <mat-icon [ngStyle]="{'color': 'green'}">done_outline</mat-icon>
                    
                  }
                </span>
              </mat-form-field>
            </ng-template>
          }
        </mat-grid-list>
        <mat-divider></mat-divider>
      </div>
    }
  } @else if (observationTypeFormArray != null && observationFilterControl.value != '') {
    <div class="benefit-family-grouping">
      <h2 class="benefit-family-grouping-title">Results for "{{ observationFilterControl.value }}"</h2>
      <mat-grid-list cols="2" rowHeight="90px">
        @for (subObservationTypeGroup of filterOnObservationValuesByFilter(observationFilterControl.value); track subObservationTypeGroup) {
          <mat-grid-tile>
            @if (subObservationTypeGroup.get('valueType').value === 'DDL') {
              <mat-form-field class="w-90">
                <mat-label>{{ subObservationTypeGroup.get('name').value }}</mat-label>
                <mat-select #selectDDLElement
                            placeholder="Select Option"
                            [formControl]="subObservationTypeGroup.get('value')">
                  @for (option of subObservationTypeGroup.get('options').value; track option.name) {
                    <mat-option [value]="option?.name">
                      {{ option?.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                  <button mat-icon-button matSuffix
                          (click)="clearSelection(selectDDLElement)">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                
                @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                  <span matSuffix class="font-small">
                    <mat-icon [ngStyle]="{'color': 'green'}">done_outline</mat-icon>
                  </span>
                }
              </mat-form-field>
            } @else {
              <!-------------------------------------->
                <!-- Container (Field + Date Field) -->
                <!-------------------------------------->
              @if (subObservationTypeGroup.get('showEffectiveDate')?.value === 1) {
                <div class="flex flex-auto justify-center">
                  <div class="w-60">
                    <ng-container *ngTemplateOutlet="defaultField;"></ng-container>
                  </div>
                  <!-------------------------------------->
                  <!-- Date Field -->
                  <!-------------------------------------->
                  <div class="w-30">
                    <mat-form-field class="w-90">
                      <mat-label>Effective Date</mat-label>
                      <input [formControl]="subObservationTypeGroup.get('effectiveDate')"
                             [matDatepicker]="completionDatePicker" matInput>
                      <mat-datepicker-toggle [for]="completionDatePicker" matIconSuffix>
                      </mat-datepicker-toggle>
                      <mat-datepicker #completionDatePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              } @else {
                <ng-container *ngTemplateOutlet="defaultField;"></ng-container>
              }
            }
          </mat-grid-tile>
          
          <ng-template #defaultField>
            <mat-form-field class="w-90">
              <mat-label>{{ subObservationTypeGroup.get('name').value }}</mat-label>
              <input [formControl]="subObservationTypeGroup.get('value')"
                     placeholder="{{subObservationTypeGroup.get('valueType').value}}"
                     [type]="getInputType(subObservationTypeGroup.get('valueType').value)"
                     [pattern]="getInputPattern(subObservationTypeGroup.get('valueType').value)"
                     matInput>
              
                @if (!isValueBlank(subObservationTypeGroup.get('value').value)) {
                  <span matSuffix class="font-small">
                    <mat-icon [ngStyle]="{'color': 'green'}">done_outline</mat-icon>
                  </span>
                }
            </mat-form-field>
          </ng-template>
        }
      </mat-grid-list>
      <mat-divider></mat-divider>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!observationTypeFormGroup.valid"
          (click)="onClickSave()">Okay
  </button>
  <button class="dialog-button" mat-raised-button (click)="onClickCancel()" color="warn">Cancel</button>
</mat-dialog-actions>
